/**
 * Medical Record types for the PilatesTime application
 */
// Record types enum
export var RecordType;
(function (RecordType) {
    RecordType["ANAMNESIS"] = "anamnesis";
    RecordType["PHYSICAL_EVALUATION"] = "physical_evaluation";
    RecordType["PERIODIC_EVALUATION"] = "periodic_evaluation";
    RecordType["TREATMENT"] = "treatment";
    RecordType["OTHER"] = "other";
})(RecordType || (RecordType = {}));
// Labels for UI display
export const RECORD_TYPE_LABELS = {
    [RecordType.ANAMNESIS]: "Anamnesis",
    [RecordType.PHYSICAL_EVALUATION]: "Physical Evaluation",
    [RecordType.PERIODIC_EVALUATION]: "Periodic Evaluation",
    [RecordType.TREATMENT]: "Treatment Plan",
    [RecordType.OTHER]: "Other",
};
//# sourceMappingURL=MedicalRecord.js.map